import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import Security from "../components/security";

class InitApp extends Component {

    componentDidMount() {
        Security.waitForInit(() => {
            this.redirect();
        }, true);
    }

    redirect() {
        let nextPath = Security.firstPath;

        const currentUser = Security.getUser();

        if (currentUser.ICHECVerifications !== false && currentUser.ICHECAdmin === false) {
            nextPath = process.env.APP_ROOT + 'verifications';
        } else if (currentUser.ICHECEtudiant === false && currentUser.ICHECAdmin === false && currentUser.ICHECProgrammes === false) {
            nextPath = process.env.APP_ROOT + 'notStudent';
        } else if (currentUser.isActive === false) {
            nextPath = process.env.APP_ROOT + 'inactiveStudent';
        } else if (currentUser.isBlocked !== false) {
            if (nextPath !== process.env.APP_ROOT + 'documents' && nextPath !== process.env.APP_ROOT + 'valves')
                nextPath = process.env.APP_ROOT + 'blockedStudent';
        } else if (currentUser.isBlocked === false && nextPath === process.env.APP_ROOT + 'blockedStudent') {
            nextPath = process.env.APP_ROOT + 'desktop';
        } else if (nextPath === process.env.APP_ROOT || nextPath === Security.firstPath && !currentUser.isRGPD && !(currentUser.ICHECAdmin === true || currentUser.ICHECProgrammes === true)) {
            nextPath = process.env.APP_ROOT + 'desktop';
        }

        setTimeout(() => {
            this.props.history.push(nextPath)
        }, 500);
    }

    render() {
        document.body.classList.add("pace-done");
        return (
            <section className="my-5">
                <h1>App Initialization</h1>
            </section>
        );
    }
}

export default withRouter(InitApp);